import { numeral } from '@fund/basic-lib';
import { market as config } from '../config';
import p from './public';
// 格式化'%'时不自动除100
numeral.options.scalePercentBy100 = false;

// 市场行情（走势图）- 净值估算
export default {

  // 格式化数据
  formatData: (row) => {
    let stockAxis = config.stockAxis.CN;
    console.log('gus z================');
    console.log(row);
    try {
      // 根据开始时间判断指数类型
      const time = row.Datas[0].split(',')[1];
      const totalCount = row.TotalCount;
      // 美股(夏令时)
      // eslint-disable-next-line no-unused-expressions
      (time === '21:30') && (stockAxis = config.stockAxis.USASummer);
      // 美股(冬令时)
      // eslint-disable-next-line no-unused-expressions
      (time === '22:30') && (stockAxis = config.stockAxis.USAWinter);
      // eslint-disable-next-line no-unused-expressions
      (totalCount === 330) && (stockAxis = config.stockAxis.HK);
    } catch (err) {
      console.error(err);
    }

    let data = [];
    // eslint-disable-next-line array-callback-return
    row.Datas.map((str, index) => {
      try {
        const sp = str.split(',');
        let dwjz = row.Expansion.DWJZ;
        if (row.Expansion.DWJZ === '-' || row.Expansion.DWJZ === '--') {
          dwjz = '--';
        }
        if (row.Expansion.DWJZ === 0) {
          dwjz = '--';
        }
        let value = '--';
        if (dwjz !== '--') {
          value = (dwjz * (1 + sp[2] / 100)).toFixed(4);
        }
        // eslint-disable-next-line radix
        // const rise = parseInt(Math.trunc(sp[2] * 100)) / 100;
        const rise = sp[2] - 0;
        data = data.concat([
          {
            date: sp[1],
            type: '估值',
            // eslint-disable-next-line no-restricted-globals
            value: isNaN(rise - 0) ? null : (rise - 0),
            // eslint-disable-next-line no-restricted-globals
            gs: isNaN(value - 0) ? null : (value - 0),
            // eslint-disable-next-line no-restricted-globals
            rise: isNaN(rise - 0) ? null : (rise - 0),
            index,
            max: stockAxis.count,
          },
        ]);
      } catch (err) {
        console.error(err);
      }
    });
    const lastPoint = data[data.length - 1];

    while (data.length < stockAxis.count) {
      data.push({
        date: data.length + 1 === stockAxis.count ? stockAxis.endTime : Math.random(),
        type: '估值',
        value: null,
        gs: null,
        rise: null,
        index: data.length,
        max: stockAxis.count,
      });
    }

    if (!data[0].date || typeof data[0].date !== 'string') {
      data[0].date = stockAxis.startTime;
    }
    console.log({ data, lastPoint });
    return { data, lastPoint };
  },

  // 绘制走势图
  drawChart(row, data, chart, changeSlideState, unitPrice, showUnitPrice, setLegend) {
    // 创建十字线组件
    const {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    } = p().createToolTipsList(chart);
    const toolTipsList = {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    };

    // let yTipsGuide;

    let maxRrise = null;
    let minRise = null;

    try {
      data.map((d) => {
        // eslint-disable-next-line no-restricted-globals
        if (d.rise && !isNaN(d.rise - 0)) {
          // eslint-disable-next-line no-unused-expressions
          (!maxRrise || d.rise > maxRrise.rise) && (maxRrise = d);
          // eslint-disable-next-line no-unused-expressions
          (!minRise || d.rise < minRise.rise) && (minRise = d);
        }
        return d;
      });
      // eslint-disable-next-line no-throw-literal
      if (!maxRrise || !minRise) throw '';
    } catch (err) {
      maxRrise = { rise: 1 };
      minRise = { rise: -1 };
      console.error(err);
    }
    let space = Math.max(Math.abs(minRise.rise - 0), Math.abs(maxRrise.rise - 0)) * 1.5;
    // const vMin = row.Expansion.DWJZ * (1 - space / 100);
    // const vMax = row.Expansion.DWJZ * (1 + space / 100);
    // const vCenter = (vMin + vMax) / 2;

    // chart.scale('value', {
    //   ticks: [vMin, (vMin + vCenter) / 2, vCenter, (vMax + vCenter) / 2, vMax],
    // });
    if (space <= 0.02) {
      space = 0.02;
    }
    chart.scale('value', {
      ticks: [-space, -space / 2, 0, space / 2, space, space + space / 2],
    });

    // 绘制走势图
    chart.source(data, p().sourceConfig);

    // 水印
    p().drawLogo(chart);

    chart.legend(false);

    chart.tooltip({
      ...p().tooltipConfig,
      yTip(val) {
        return {
          ...p().yTipsConfig,
          text: numeral(val).format('0.00%', Math.trunc),
        };
      },
      onChange: (obj) => {
        p().tooltipOnChange();
        const point = obj.items[0].origin;
        changeSlideState(true);

        // 显示十字线
        // p().showToolTips(
        //   toolTipsList,
        //   obj.items[0],
        //   (val) => numeral(val).format('0.0000', Math.trunc),
        //   (date) => date,
        // );

        setLegend([
          point.date, // 0 日期
          point.gs, // 1 估值
          point.rise, // 2 涨幅
        ]);
        // 显示十字线
        p().showToolTips(toolTipsList, obj.items[0], (val) => numeral(val).format('0.00%', Math.trunc));
      },
      onHide: () => {
        p().tooltipOnHide();
        changeSlideState(false);
        // yTipsGuide.remove();

        // 隐藏十字线
        // p().hideToolTIps(toolTipsList);
      },
    });

    chart.axis('value', {
      label: function label(text) {
        return {
          ...p().yAxisConfig,
          text: numeral(text).format('0.00%', Math.trunc),
        };
      },
    });

    chart.axis('date', {
      ...p().xAxisGridConfig,
      label: function label(text, index, total) {
        let textCfg = {
          text,
        };
        if (index === 0) {
          textCfg.textAlign = 'left';
        } else if (index === total - 1) {
          textCfg.textAlign = 'right';
        } else {
          textCfg = null;
        }
        return textCfg && { ...p().xAxisConfig, ...textCfg };
      },
    });

    // yTipsGuide = chart.guide().html({
    //   position: ['max', 'max'],
    //   html: '<div style="display:none"></div>',
    //   alignX: 'left',
    //   alignY: 'top',
    //   offsetX: 2,
    //   offsetY: -7,
    // });

    // // eslint-disable-next-line no-param-reassign
    // chart.yTipsGuide = yTipsGuide;

    let nowRise = null;
    // eslint-disable-next-line array-callback-return
    data.map((d) => {
      if (d.rise !== null) {
        nowRise = d.rise;
      }
    });

    // 画摊薄成本线
    if (unitPrice !== null && row.Expansion.DWJZ) {
      // console.log(`====== ${row.Expansion.DWJZ}`);
      const unitPricerise = ((unitPrice / row.Expansion.DWJZ) - 1) * 100;
      // console.log(`====== ${unitPricerise}   ${space}`);
      if (unitPricerise > -space && unitPricerise < space) {
        chart.guide().line({
          start: ['min', unitPricerise],
          end: ['max', unitPricerise],
          style: {
            stroke: '#f40', // 线的颜色
            lineDash: [0, 2, 2], // 虚线的设置
            lineWidth: 1, // 线的宽度
          },
          limitInPlot: true,
        });
      }
    }

    const nowColor = nowRise >= 0 ? config.colors[0] : '#2db330';
    chart.line({ connectNulls: true }).position('date*value').color('type', nowRise >= 0 ? config.colors : '#2db330').size(2)
      .animate(false);

    // 标结束点
    p().drawEndPoint(chart, data, nowColor);

    chart.render();
  },
};
